const GRADER_INPUT_MAP = {
  psa: 'psa',
  beckett: 'beckett',
  bgs: 'beckett',
  bvg: 'beckett',
  sgc: 'sgc',
  cgc: 'cgc',
  csg: 'cgc',
};

export function normalizeCertLookupGrader(grader) {
  const graderInput = grader && `${grader}`.trim().toLowerCase();
  return graderInput && GRADER_INPUT_MAP[graderInput];
}

export function getCertLookupValidationError(cert, grader) {
  if (!cert || typeof cert !== 'string' || !cert.trim()) {
    return 'Cert number is required';
  }

  const normalizedGrader = normalizeCertLookupGrader(grader);

  if (!normalizedGrader) {
    return `Grader must be one of: ${Object.keys(GRADER_INPUT_MAP).join(', ')}`;
  }

  const normalizedCert = cert.trim();

  if (normalizedGrader === 'psa') {
    if (!/^\d{8,9}$/.test(normalizedCert)) {
      return 'PSA cert number must be 8 or 9 digits';
    }
  } else if (normalizedGrader === 'sgc') {
    if (!/^[\d-]+$/.test(normalizedCert)) {
      return 'SGC cert number must contain only digits and hyphens';
    }
  } else if (normalizedGrader === 'beckett' || normalizedGrader === 'cgc') {
    if (!/^\d+$/.test(normalizedCert)) {
      return 'Cert number must contain only digits';
    }
  }

  return null;
}

export function isCertLookupInputValid(cert, grader) {
  return !getCertLookupValidationError(cert, grader);
}

export function normalizeCertLookupInput(cert, grader) {
  const validationError = getCertLookupValidationError(cert, grader);

  if (validationError) {
    return { error: validationError };
  }

  const normalizedGrader = normalizeCertLookupGrader(grader);
  let normalizedCert = cert.trim();

  if (normalizedGrader === 'beckett' && normalizedCert.startsWith('0')) {
    normalizedCert = normalizedCert.replace(/^0+/, '');
  }

  return {
    cert: normalizedCert,
    grader: normalizedGrader,
  };
}
